(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-slideshow"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (!window.Shopify || !window.Shopify.designMode) return;

    document.addEventListener('shopify:section:load', function (event) {
      if (!event.target.matches('.shopify-section--custom-slideshow')) return;

      event.target.querySelectorAll('.slideshow__slide.is-selected video-media').forEach(function (media) {
        if (media.offsetParent === null || typeof media.play !== 'function') return;
        media.play({ restart: true });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mf-concept"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function clamp(v, a, b) { return v < a ? a : v > b ? b : v; }

    function initScene(scene) {
      if (scene.dataset.conceptInit) return;
      if (!window.matchMedia('(prefers-reduced-motion: no-preference)').matches) return;
      scene.dataset.conceptInit = 'true';

      var bg = scene.querySelector('.mf-concept__bg');
      var shade = scene.querySelector('.mf-concept__shade');
      var heading = scene.querySelector('.mf-concept__heading');
      var chars = Array.prototype.slice.call(scene.querySelectorAll('.mf-concept-char'));
      var body = scene.querySelector('.mf-concept__body');
      var logo = scene.querySelector('.mf-concept__logo');
      var btn = scene.querySelector('.mf-concept__btn');
      var steps = [body, logo, btn].filter(Boolean);
      var shadeMax = parseFloat(scene.dataset.shade) || 0.55;

      var EXPAND_VH = 0.8;
      var DARK_START_VH = 0.45;
      var DARK_LEN_VH = 0.6;

      scene.classList.add('is-init');
      if (bg) bg.classList.add('is-before');

      var bgH = 0;
      var total = 1;
      function measure() {
        bgH = bg ? bg.offsetHeight : window.innerHeight;
        total = scene.offsetHeight - bgH;
        if (total < 1) total = 1;
      }
      measure();

      var ticking = false;
      function onScroll() {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(update);
      }

      function update() {
        ticking = false;
        var vh = window.innerHeight || document.documentElement.clientHeight;
        var top = scene.getBoundingClientRect().top;
        var s = -top;

        if (bg) {
          var state;
          if (top > 0) state = 'is-before';
          else if (top < -total) state = 'is-after';
          else state = 'is-pinned';
          if (!bg.classList.contains(state)) {
            bg.classList.remove('is-before', 'is-pinned', 'is-after');
            bg.classList.add(state);
          }
        }

        scene.style.setProperty('--mf-e', clamp(s / (vh * EXPAND_VH), 0, 1).toFixed(3));

        if (shade) {
          var dp = clamp((s - vh * DARK_START_VH) / (vh * DARK_LEN_VH), 0, 1);
          shade.style.opacity = (dp * shadeMax).toFixed(3);
        }

        if (chars.length && heading) {
          var ht = heading.getBoundingClientRect().top;
          var hp = clamp((vh * 0.86 - ht) / (vh * 0.36), 0, 1);
          var n = chars.length;
          var spread = 5;
          for (var i = 0; i < n; i++) {
            chars[i].style.opacity = clamp((hp * (n + spread) - i) / spread, 0, 1).toFixed(3);
          }
        }
        for (var j = 0; j < steps.length; j++) {
          var st = steps[j].getBoundingClientRect().top;
          steps[j].style.opacity = clamp((vh * 0.86 - st) / (vh * 0.28), 0, 1).toFixed(3);
        }
      }

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', function () { measure(); onScroll(); }, { passive: true });
      window.addEventListener('load', function () { measure(); onScroll(); });
      update();
    }

    function initAll() {
      document.querySelectorAll('[data-mf-concept]').forEach(initScene);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mf-stitch-divider"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function clamp(v, a, b) { return v < a ? a : v > b ? b : v; }

    function initStitch(el) {
      if (el.dataset.mfStitchInit) return;
      if (!window.matchMedia('(prefers-reduced-motion: no-preference)').matches) return;
      el.dataset.mfStitchInit = 'true';

      var track = el.querySelector('.mf-stitch__track');
      if (!track) return;
      el.classList.add('is-motion');

      var target = null;
      if (el.hasAttribute('data-mf-stitch-reveal-next')) {
        var wrap = el.closest('.shopify-section');
        target = wrap ? wrap.nextElementSibling : null;
        if (target) target.style.willChange = 'opacity';
      }

      var ticking = false;
      function onScroll() {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(update);
      }

      function update() {
        ticking = false;
        var vh = window.innerHeight || document.documentElement.clientHeight;
        var r = el.getBoundingClientRect();

        var lineY = r.top + r.height / 2;
        var startY = vh * 0.72;
        var endY = vh * 0.42;
        var p = clamp((startY - lineY) / (startY - endY), 0, 1);
        track.style.setProperty('--mf-stitch-clip', ((1 - p) * 100).toFixed(2) + '%');

        if (target) {
          var tTop = target.getBoundingClientRect().top;
          var ts = vh * 0.62;
          var te = vh * 0.32;
          var tp = clamp((ts - tTop) / (ts - te), 0, 1);
          target.style.opacity = tp.toFixed(3);
        }
      }

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      window.addEventListener('load', onScroll);
      update();
    }

    function initAll() {
      document.querySelectorAll('[data-mf-stitch]').forEach(initStitch);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();
})();
